<div class="row reviewTab">

  <ng-container *ngIf="hasReview == true">
  <!-- Rank -->
  <ng-container *ngIf="evaluationSummary!=null">
    <div class="col-md-12">
      <div class="car-rank d-flex mr-2 mb-4">
        <span class="reviewRank badge badge-pill badge-primary mr-2">{{evaluationSummary.average}}</span>
       <div>
        {{evaluationSummary.resourceName}}<br />
        <span class="review-number">({{evaluationSummary.countEvaluation}} {{ 'Reviews' | translate }})</span>
       </div>
      </div>
    </div>
    </ng-container>

    <!-- Average Criteria Details -->
    <ng-container *ngIf="evaluationSummary!=null">
    <div *ngFor="let review of evaluationSummary.evaluationLogsDetails" class="col-md-6">
      <div class="slideContainer">
        <div class="d-flex">
          <div class="mr-auto slideCriteria">{{review.description}}</div>
          <!-- <div class="slideValue badge badge-pill badge-primary">{{review.average}}</div> -->
        </div>
        <mat-slider disabled class="mb-2" min="0" max="10" [value]="review.average"></mat-slider>
      </div>
    </div>
    </ng-container>

    <div class="reviewComments ">
      <div *ngFor="let reviewComment of evaluationLogsMasterList">
        <div class="row m-0 mb-4">
          <div class="col-md-2 text-center">
            <!-- Todo: Make the Reviewer image dynamic (come form API) -->
            <!-- <img width="60px" src="assets/img/defulat-profile-pic.svg"> -->
            <img  width="60px"
            [src]="attachmentService.getImageLink(reviewComment.evaluatorRefID,attachmentScopesEnum.Customer, attachmentTypeEnum.CustomerIndividualImage)"
            >
            <div class="reviewName">{{reviewComment.createdBy}}</div>
          </div>
          <div class="col-md-10">
            <div class="reviewBox">
              <div class="badge badge-pill badge-primary">{{reviewComment.average}} </div>
              <div class="review-date"> {{reviewComment.createdOnDateString}}  {{reviewComment.createdOnTimeString}} </div>
              <div class="d-flex">
                <div class="reviewComment mt-2 mr-auto">{{reviewComment.evaluatorComment}}</div>
                <!-- <div class="veiwDetails"><a href="#">{{ 'VeiwDetails' | translate }}</a></div> -->
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </ng-container>


  <ng-container *ngIf="hasReview == false">
   <div class="col-md-12 no-available-reviews">
    {{ 'NoAvailableReviews' | translate }}
   </div>
  </ng-container>


</div>
